// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"012fd69d","455":"29b1c9e0","977":"c4242724"}[chunkId] + ".chunk.js";
};